import { MediaValue } from 'UIComponents';
import { useImageValueController } from './controller';

export function ImageValue() {
  const { value, type, handleRemove } = useImageValueController();

  return <MediaValue value={value} type={type} handleRemove={handleRemove} />;
}
